export class Processo {
  id: string;
  nome: string;
  descricao: string;
  responsavel_valia: string;
}